import { useState } from 'react'

/**
 * Custom hook for table pagination
 * Manages page state, rows per page, and handlers for pagination controls
 * 
 * @param {number} initialRowsPerPage - Initial number of rows per page (default: 10)
 * @returns {Object} Pagination state and handlers
 */
export function usePagination(initialRowsPerPage = 10) {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const resetPage = () => {
        setPage(0)
    }

    return {
        page,
        rowsPerPage,
        handleChangePage,
        handleChangeRowsPerPage,
        resetPage,
        setPage,
        setRowsPerPage,
    }
}
